import {connect} from 'react-redux';
import {connectIntl} from 'redux-intl-connect';
export default connectIntl(connect);



// WEBPACK FOOTER //
// ./src/custom/connect.js